import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { POSTHOG_PLATFORM } from './posthog-platform.token';
import { PostHogRouteTrackingService } from './posthog-route-tracking.service';

/** Depends on `provideRmaPostHog` having bound `POSTHOG_PLATFORM`, so it is called alongside it. */
export function provideRmaPostHogRouteTracking(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const platform = inject(POSTHOG_PLATFORM);
      const routeTracking = inject(PostHogRouteTrackingService);

      if (!platform.isTrackable) {
        return;
      }

      routeTracking.init();
    }),
  ]);
}
